document.addEventListener('DOMContentLoaded', function() {
  let wishlist;

  // Load wishlist from localStorage
  try {
    wishlist = JSON.parse(localStorage.getItem('playpatch_wishlist') || '[]');
  } catch (e) {
    wishlist = [];
  }

  function saveWishlist() {
    localStorage.setItem('playpatch_wishlist', JSON.stringify(wishlist));
  }

  function syncUI() {
    document.querySelectorAll('[data-wishlist-button]').forEach(function(btn) {
      const handle = btn.dataset.productHandle;
      if (!handle) return;

      if (wishlist.includes(handle)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  // 🔥 EVENT DELEGATION — fixes bottom half buttons
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-wishlist-button]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.dataset.productHandle;
    if (!handle) return;

    // Toggle wishlist
    const index = wishlist.indexOf(handle);
    if (index !== -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(handle);
    }

    saveWishlist();
    syncUI();
  });

  // Initial sync
  syncUI();
});

document.addEventListener('wishlist-updated', syncUI);
